const THRESHOLD = 0x10000;
const HEX_RADIX = 16;

class TracingService {
  generateTraceId = () => this.s4() + this.s4() + this.s4() + this.s4() + this.s4() + this.s4() + this.s4() + this.s4();
  generateSpanId = () => this.s4() + this.s4() + this.s4() + this.s4();

  s4 = () =>
    Math.floor((1 + Math.random()) * THRESHOLD)
      .toString(HEX_RADIX)
      .substring(1);

  generateHeaders = (sampled) => {
    return {
      'X-B3-TraceId': this.generateTraceId(),
      'X-B3-SpanId': this.generateSpanId(),
      'X-B3-Sampled': sampled ? sampled : 1,
    };
  };
}

export default new TracingService();
